import { formatarContagem } from '@/lib/format';

export interface PaginacaoProps {
  offset: number;
  limit: number;
  quantidade: number;
  total: number;
  onMudar: (offset: number) => void;
  testId?: string;
}

/** "Mostrando 1–10 de TOTAL" com Anterior/Próxima. O total e o da API. */
export function Paginacao({ offset, limit, quantidade, total, onMudar, testId }: PaginacaoProps) {
  const de = total === 0 ? 0 : offset + 1;
  const ate = offset + quantidade;
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-border pt-3 text-small text-ink-secondary">
      <span data-testid={testId}>{`Mostrando ${formatarContagem(de)}–${formatarContagem(ate)} de ${formatarContagem(total)}`}</span>
      <div className="flex gap-1.5">
        <button type="button" disabled={offset <= 0} onClick={() => onMudar(Math.max(0, offset - limit))} className="h-8 rounded-lg border border-border bg-card px-3 text-small hover:bg-line-soft disabled:opacity-50">
          Anterior
        </button>
        <button type="button" disabled={ate >= total} onClick={() => onMudar(offset + limit)} className="h-8 rounded-lg border border-border bg-card px-3 text-small hover:bg-line-soft disabled:opacity-50">
          Próxima
        </button>
      </div>
    </div>
  );
}
